<template>
  <div :id="chartId" class="HighStock flx1"></div>
</template>

<script>
import Highcharts from 'highcharts/highstock';
import { uuid4, } from '@/script/CommonTools';

export default {
  name: 'CommonChartX',
  props: [ 'inhertParentHeight', 'data', 'yTitle', 'legend', 'xFormat', 'type', 'showValue', 'rangeSelector', 'rangeSelectorSelected', ],
  data() {
    return {
      chartId: null,
      chartOptions: null,
    };
  },
  computed: {
  },
  methods: {
    initOptions() {
      const newData = [ ...this.data ];
      let yAxisLeft = false;
      let yAxisRight = false;
      let yAxisReverse = false;
      let sideChart = false;
      const yAxis = [ ];
      let stacking = false;
      newData.forEach((it) => {
        // side chart 和 reverse
        if (it.sideChart) {
          sideChart = true;
        } else if (it.yAxisReverse) {
          yAxisReverse = true;
        } else {
          if (it.yAxisSide === 'left') {
            yAxisLeft = true;
          }
          if (it.yAxisSide === 'right') {
            yAxisRight = true;
          }
        }
        if (it.stack !== null && it.stack !== undefined && it.stack !== '') {
          stacking = true;
        }
      });
      newData.forEach((it) => {
        // side chart 和 reverse
        if (it.sideChart) {
          it.yAxis = yAxisLeft && yAxisRight ? 2 : 1;
        } else if (it.yAxisReverse) {
          it.yAxis = 1;
        } else {
          if (it.yAxisSide === 'left') {
            it.yAxis = 0;
          }
          if (it.yAxisSide === 'right') {
            it.yAxis = 1;
          }
        }
      });
      // y axis for left
      if (yAxisLeft || (!yAxisLeft && !yAxisRight)) {
        let data = { title: null, opposite: false, };
        if (yAxisReverse) {
          data.height = '50%';
          data.min = 0;
        }
        if (sideChart) {
          data.height = '70%';
        }
        yAxis.push(data);
      }
      // y axis for right
      if (yAxisRight) {
        let data = { title: null, opposite: true, };
        if (sideChart) {
          data.height = '70%';
        }
        yAxis.push(data);
      }
      // y axis for side chart
      if (sideChart) {
        yAxis.push({ title: null, opposite: false, height: '30%', top: '70%', min: 0, });
      }
      // y axis for reverse chart
      if (yAxisReverse) {
        yAxis.push({ title: null, opposite: false, reversed: true, height: '50%', top: '50%', min: 0, });
      }

      const chartType = this.type ? this.type : 'line';
      const rangeSelectorButtons = [ ];
      this.rangeSelector.forEach((it) => {
        if (it.endsWith('m')) {
          rangeSelectorButtons.push({
            type: 'month',
            text: it,
            count: parseInt(it.substring(0, it.length-1)),
          });
        } else if (it.endsWith('y')) {
          rangeSelectorButtons.push({
            type: 'year',
            text: it,
            count: parseInt(it.substring(0, it.length-1)),
          });
        } else if (it === 'ytd') {
          rangeSelectorButtons.push({
            type: 'ytd',
            text: 'YTD'
          });
        } else if (it === 'All') {
          rangeSelectorButtons.push({
            type: 'all',
            text: 'All'
          });
        }
      });

      const opts = {
        title: { text: null, },
        time: {
          useUTC: false,
        },
        // chart: { type: chartType, },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            millisecond: this.xFormat === 'day' ? '%Y/%m/%d' : '%H:%M:%S.%L',
            second: this.xFormat === 'day' ? '%Y/%m/%d' : '%Y/%m/%d<br/>%H:%M:%S',
            minute: this.xFormat === 'day' ? '%Y/%m/%d' : '%Y/%m/%d<br/>%H:%M',
            hour: this.xFormat === 'day' ? '%Y/%m/%d' : '%Y/%m/%d<br/>%H:%M',
            day: '%Y/%m/%d',
            week: '%Y/%m/%d',
            month: '%Y-%m',
            year: '%Y',
          },
          ordinal: false,
        },
        yAxis: yAxis,
        legend: {
          enabled: this.legend !== null,
          layout: this.legend === 'center' ? 'horizontal' : 'vertical',
          align: this.legend,
          verticalAlign: this.legend === 'center' ? 'top' : 'middle'
        },
        navigator: {
          enabled: true,
          height: 20,
        },
        rangeSelector: {
          enabled: this.rangeSelector !== null,
          /*
          buttons: [{
              type: 'month',
              count: 1,
              text: '1m',
          }, {
              type: 'month',
              count: 3,
              text: '3m',
          }, {
              type: 'month',
              count: 6,
              text: '6m',
          }, {
              type: 'ytd',
              text: 'YTD',
          }, {
              type: 'year',
              count: 3,
              text: '3y',
          }, {
              type: 'year',
              count: 5,
              text: '5y',
          }, {
              type: 'all',
              text: 'All',
          }],
          */
          buttons: rangeSelectorButtons,
          selected: this.rangeSelectorSelected,
          // selected: -1,
        },
        plotOptions: {
          series: {
            states: {
              inactive: {
                opacity: 1,
              }
            }
          },
          column: stacking ? { stacking: 'normal' } : { dataGrouping: { enabled: false, }, },
          line: { dataGrouping: { enabled: false, }, },
          area: stacking ? { stacking: 'normal' } : {},
          dataGrouping: { enabled: false, },
        },
        tooltip: {
          xDateFormat: '%Y-%m-%d %H:%M',
          split: false,
          shared: true,
        },
        series: newData,
        credits: { enabled: false, },
      };
      if (this.showValue) {
        if (chartType === 'line') {
          opts.plotOptions.line = {
            dataLabels: { enabled: true },
          };
        }
        else if (chartType === 'bar') {
          opts.plotOptions.bar = {
            dataLabels: { enabled: true },
          };
        }
      }
      if (chartType === 'stackingArea') {
        opts.plotOptions.area = { stacking: 'normal', };
      }
      console.log('=========================');
      console.log(opts);
      this.chartOptions = opts;
    },
  },
  mounted() {
    setTimeout(() => {
      Highcharts.stockChart(this.chartId, this.chartOptions);
    }, 1000);
  },
  created() {
    this.chartId = uuid4();
    this.initOptions();
    // Highcharts.setOptions(this.chartOptions);
  },
};
</script>

<style scoped>
.height100p {
  height: 100%;
}
</style>
